import { useState } from "react";
import React from "react";
import AIPoweredPsychometricTestsbanner from "../../AVHRBanner/AlPoweredPsychometricNB.png";
import {
  FaUser,
  FaSuitcase,
  FaBrain,
  FaSmileBeam,
  FaBalanceScale,
  FaMapMarkedAlt,
  FaRobot,
  FaUserCheck,
  FaChartBar,
  FaClock,
  FaHeadset,
  FaUserCircle,
  // FaBrain,
  FaHeart,
  FaEye,
  FaCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import skills from "../../Images/AiPTest2.png";
import AIPowerimage from "../../Images/AIPTestimg1.png";

function AIPoweredPsychometricTests() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  // const features = [
  //   {
  //     icon: <FaRobot className="text-3xl text-primary" />,
  //     label: "AI-Powered Recommendations",
  //   },
  //   {
  //     icon: <FaUserCheck className="text-3xl text-primary" />,
  //     label: "Covers Personality, Aptitude, Interest, and Learning Style",
  //   },
  //   {
  //     icon: <FaChartBar className="text-3xl text-primary" />,
  //     label: "Instant 20+ Page Report",
  //   },
  //   {
  //     icon: <FaClock className="text-3xl text-primary" />,
  //     label: "Takes Only 15–20 Minutes",
  //   },
  //   {
  //     icon: <FaHeadset className="text-3xl text-primary" />,
  //     label: "Expert Interpretation Support (Optional)",
  //   },
  // ];

  const features = [
    {
      icon: <span className="text-4xl">🤖</span>,
      label: "AI-Powered Recommendations",
    },
    {
      icon: <span className="text-4xl">🧠</span>,
      label: "Covers Personality, Aptitude, Interest, and Learning Style",
    },
    {
      icon: <span className="text-4xl">📄</span>,
      label: "Instant 20+ Page Report",
    },
    {
      icon: <span className="text-4xl">⏱️</span>,
      label: "Takes Only 15–20 Minutes",
    },
    {
      icon: <span className="text-4xl">🎧</span>,
      label: "Expert Interpretation Support (Optional)",
    },
  ];

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={AIPoweredPsychometricTestsbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt="Career Transitioning Banner"
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Edu Support</p>

              <h1 className="career-library-heading">
                AI Powered Psychometric Tests
              </h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">
               Discover Your True Potential with AI Insights
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              Discover your true strengths, personality traits, and career
              inclinations through our advanced Al-driven psychometric
              assessments. Whether you're a student, or a professional, our
              tests provide deep insights into your personality, interests,
              aptitude, learning styles and emotional intelligence
            </p>
          </div>
        </div>

        <div
          className="py-10 px-4 sm:px-6 lg:px-20 carrerbackgroundcolour pt-2"
          style={{ backgroundColor: "#E4EFE7" }}
        >
          <h2 className="text-center mb-2 avhrProject-h2">
            Understanding AI Powered Psychometric Tests
          </h2>

          <div className="grid">
            <div className="col-12 grid">
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaUser className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🧪</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">Scientific Tools</h3>
                  <p className="avhrProject-p">
                    Measure personality traits, interests, aptitude, learning
                    styles and behaviour
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaSuitcase className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">📊</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Comprehensive Insights
                  </h3>
                  <p className="avhrProject-p">
                    Provide a deeper understanding of your strengths,
                    preferences, and areas for growth
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaBrain className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">🧠</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Practical Applications
                  </h3>
                  <p className="avhrProject-p">
                    Provide a deeper understanding of your strengths,
                    preferences, and areas for growth
                  </p>
                </div>
              </div>

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                {/* <FaSmileBeam className="circelcolour text-5xl mt-4" /> */}
                <span className="text-5xl mt-4">✅</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">Reliable & Accurate</h3>
                  <p className="avhrProject-p">
                    Trusted assessments that guide personal development and
                    informed decision-making
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="col-12 text-center md:text-left mt-4 mb-4 pl-6 pr-6 md:mb-0">
          <img
            src={AIPowerimage}
            alt="Outcomes Illustration"
            className="w-full md:w-3/4 border-round-lg shadow-4 mx-auto md:mx-0"
          />
        </div>

        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center px-6 py-10"
          style={{ backgroundColor: "#FEFDED" }}
        >
          {/* Left Text Content */}
          <div>
            <h2 className="mb-4 avhrProject-h2">
              🎯 Purpose: Educate users about test dimensions
            </h2>
          </div>
        </div>

        <div
          className="grid align-items-center px-3 md:px-6 py-2"
          style={{ backgroundColor: "#FEFDED" }}
        >
          <div className="col-12 lg:col-6">
            <div className="flex items-start gap-3 mb-2">
              {/* <FaCircle className="circelcolour text-5xl mt-4" /> */}
              <span className="text-5xl mt-4">🧍‍♂️</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Personality Assessment</h3>
                <p className="avhrProject-p">
                  Find out your personality type (Introvert/Extrovert,
                  Thinker/Feeler, etc.) and what careers suit your traits
                </p>
              </div>
            </div>

            {/* Item 2 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaBrain className="circelcolour text-5xl mt-4" /> */}
              <span className="text-5xl mt-4">🧠</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Aptitude Analysis</h3>
                <p className="avhrProject-p">
                  Covers logical reasoning, verbal ability, numerical ability,
                  and spatial thinking
                </p>
              </div>
            </div>

            {/* Item 3 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaHeart className="circelcolour text-5xl mt-4" /> */}
              <span className="text-5xl mt-4">❤️</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">Interest Mapping</h3>
                <p className="avhrProject-p">
                  Helps identify where your passion lies across 100+ career
                  domains
                </p>
              </div>
            </div>

            {/* Item 4 */}
            <div className="flex items-start gap-3 mb-2">
              {/* <FaEye className="circelcolour text-5xl mt-4" /> */}
              <span className="text-5xl mt-4">👁️</span>
              <div>
                <h3 className=" mb-2 avhrProject-h3">
                  Learning Style Indicator
                </h3>
                <p className="avhrProject-p">
                  Visual, Auditory, or Kinesthetic? Understand your best study
                  style
                </p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="col-12 lg:col-6 text-center md:text-left mb-2 md:mb-0">
            <img
              src={skills}
              alt="Outcomes Illustration"
              className="w-full border-round-lg shadow-4"
            />
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background:
                "linear-gradient(-60deg, #FFE680, #E59EC2, #F28DAE, #FF7F7F)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Take the first step towards discovering your ideal career path
              <br className="mt-1" />
              Let our Al-powered insights guide you to success
              <br className="mt-1" />
              Start your assessment Today
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default AIPoweredPsychometricTests;
